<template>
  <div class="container">
    <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('spm.trak')" prop="serialNo">
            <!--评分任务编号-->
            <el-input v-model.trim="createParams.serialNo" clearable disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!--创建人-->
          <el-form-item :label="$t('common.createBy')" prop="createBy">
            <el-input v-model.trim="userCd" clearable disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('DC.createDate')" prop="createDate">
            <!--创建日期-->
            <el-date-picker v-model="createParams.createDate" type="date" value-format="yyyy-MM-dd" disabled :placeholder="$t('common.selDate')"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="Category1" prop="category1Id">
            <el-select v-model="createParams.category1Id" clearable @change="changeCategory1()">
              <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--Category2-->
        <el-col :span="8">
          <el-form-item label="Category2" prop="category2Id">
            <el-select v-model="createParams.category2Id" clearable>
              <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="needSupplierSelfMark">
            <el-checkbox v-model="needSupplierSelfMark">{{$t('spm.needSupplierSelfMark')}}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <!--评分截止日期-->
          <el-form-item :label="$t('spm.finishDate')" prop="finishDate">
            <el-date-picker v-model="createParams.finishDate" value-format="yyyy-MM-dd" type="date" style="width: 180px;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="toolsBox" style="padding-top: 15px;">
      <el-button type="primary" @click="showSupplierDialog = true">{{$t('common.add')}}</el-button>
      <el-button type="primary" @click="delSupplier">{{$t('common.del')}}</el-button>
    </div>
    <el-table :data="supplierList" ref="supplierList" border highlight-current-row style="margin-top:15px;">
      <el-table-column type="selection"></el-table-column>
      <!--供应商编号/邀请码-->
      <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('spm.invitationCode')"></el-table-column>
      <!--供应商名称-->
      <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('spm.supplierName')"></el-table-column>
      <!--供应商类型-->
      <el-table-column show-overflow-tooltip prop="groupType" :label="$t('spm.supplierType')"></el-table-column>
    </el-table>
    <!--底部操作按钮-->
    <el-row type="flex" justify="center" style="padding-top: 15px;">
      <el-button type="primary" @click="save('DRAFT')">{{$t('common.saveDraft')}}</el-button>
      <el-button type="primary" @click="save('push')">{{$t('spm.pushScore')}}</el-button>
      <el-button type="primary" @click="routerBack">{{$t('common.close')}}</el-button>
    </el-row>
    <supplier-dialog :is-show.sync="showSupplierDialog" :create-fun="onSupplier" @hideDialog="showSupplierDialog = false" />
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "@/api/spm/spm-manage";
import supplierDialog from "@/components/page/ssr-manage/supplier-dialog";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import Moment from "moment";

export default {
  name: "spm-manage-add",
  components: {
    supplierDialog,
    IcSelect
  },
  data() {
    return {
      createParams: {
        serialNo: null,
        finishDate: null,
        createBy: null,
        category1Id: null,
        category2Id: null,
        needSupplierSelfMark: true,
        supplierIds: [],
        status: null,
        createDate: this.$options.filters["dateFormatFilter"](new Date()),
      },
      needSupplierSelfMark: true,
      showSupplierDialog: false,
      userCd: null,
      supplierList: [],
      categoryList1: [],
      categoryList2: [],


    };
  },
  created() {
    this.createParams.createBy = localStorage.getItem("ms_userId");
    this.userCd = localStorage.getItem("ms_userCd");
    //默认值当前日期+14天
    const myDate = new Date();
    this.createParams.finishDate = this.$options.filters["dateFormatFilter"](myDate.setDate(myDate.getDate() + 14))
    this.id = this.$route.query.id;
    if (this.id) {
      this.getById()
    }
    this.getCategoryList(1)
  },
  methods: {
    //查询详情
    getById() {
      apiService.getById(this.id).then(res => {
        if (res.data) {
          this.createParams = res.data.supplierMark;
          this.supplierList = res.data.supplierMark.suppliers;
          if (this.createParams.needSupplierSelfMark === 'Y') {
            this.needSupplierSelfMark = true
          }
          this.changeCategory1()
        }
      });
    },
    //删除供应商清单
    delSupplier() {
      let val = this.$refs.supplierList.selection;
      const ids = val.map(item => item.tmSupplierId);
      if (ids.length > 0) {
        for (const id of ids) {
          for (var i = 0; i < this.supplierList.length; i++) {
            if (id === this.supplierList[i].tmSupplierId) {
              this.supplierList.splice(i, 1);
            }
          }
        }
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess")
        });
      } else {
        this.$message({
          type: "error",
          message: this.$t("common.pleaseSelectData")
        });
      }
    },
    // 添加供应商
    onSupplier(data) {
      // this.supplierList = this.supplierList.concat(data)
      let list = data.filter(sup => !this.supplierList.some(tmp => tmp.tmSupplierId == sup.tmSupplierId));
      if (commonFun.isNotEmpty(list)) {
        this.supplierList.push(...list);
      }
      this.showSupplierDialog = false
    },
    //保存+发布评分
    save(type) {
      if (type === 'push') {
        if (this.supplierList.length < 1) {
          this.$message({
            message: '请添加供应商',
            type: "warning"
          });
        }
        type = this.needSupplierSelfMark ? 'TO_SUP_SORE' : 'TO_SS_SORE'
      }
      if (this.needSupplierSelfMark) {
        this.createParams.needSupplierSelfMark = 'Y'
        if (!this.createParams.finishDate) {
          this.$message({
            message: '评分完成日期”为必填',
            type: "warning"
          });
          return
        }
      } else {
        this.createParams.needSupplierSelfMark = 'N'
      }
      const supplierIds = this.supplierList.map(item => item.tmSupplierId);
      this.createParams.supplierIds = supplierIds
      this.createParams.status = type
      let param = {
        bigCategoryDtos: [],
        scoreDataDtos: [],
        scoreDataDtosup: [],
        supplierMark: this.createParams,
        suppliers: [],
      }
      apiService.toAddSupplierMark(param).then(res => {
        if (res.code === '200') {
          this.$message({
            message: this.$t("common.operateSuccess"),
            type: "success"
          });
          if (type == 'DRAFT') {
            this.id = res.data.ttSupplierMarkId;
            this.getById()
          } else {
            this.routerBack();
          }
        } else {
          Message.error(res.msg || this.$t("common.operateError"));
        }
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      // this.createParams.category2Id = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.createParams.category1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.needSupplierSelfMark .el-form-item__content {
  margin-left: 50px !important;
}
</style>
